import React from "react";
import {
  View,
  TouchableOpacity,
  Modal,
  StyleSheet,
  Dimensions,
} from "react-native";
import Text from "@components/CustomText";
import { useSelector, useDispatch } from "react-redux";
import NavigationService from "@utils/NavigationService";
import { actions as supportActions } from "@reducers/supportReducer";
import colors from "@constants/color";

import t from "@constants/localization";

const PATH = "screens/SupportTree/components/CreateTicketDialog";

const TicketDialog = () => {
  const {
    showDialog = false,
    ticketId,
    message,
    buttonText1,
    buttonText2,
    endingMessage,
    buttonText2Color,
  } = useSelector((state) => state.support);
  const dispatch = useDispatch();

  const navigateToSupport = () => {
    if (NavigationService && typeof NavigationService.navigate === "function") {
      NavigationService.reset({
        index: 1,
        routes: [
          {
            name: "Bottoms",
          },
          { name: "SupportTree" },
        ],
      });
      dispatch(
        supportActions.showCreateTicketModal({
          show: false,
          id: null,
          message: "",
          buttonText1: "",
          buttonText2: "",
          endingMessage: "",
        }),
      );
    }
  };

  const navigateToTicket = (id) => {
    if (NavigationService && typeof NavigationService.reset === "function") {
      // ticket details ---> all tickets --> landing page --> bottoms
      NavigationService.reset({
        index: 2,
        routes: [
          { name: "Bottoms" },
          { name: "SupportTree" },
          { name: "SupportTickets" },
          {
            name: "SupportTicket",
            params: { ticketId: id },
          },
        ],
      });
      dispatch(
        supportActions.showCreateTicketModal({
          show: false,
          id: null,
        }),
      );
    }
  };
  return (
    <Modal statusBarTranslucent navigationBarTranslucent visible={showDialog}>
      <View
        style={{
          flex: 1,
          backgroundColor: "rgba(0,0,0,0.6)",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <View
          style={{
            backgroundColor: "white",
            borderRadius: 10,
            elevation: 4,
            padding: 24,
            width: Dimensions.get("screen").width - 40,
          }}
        >
          <Text variant="title_18_semi">{t(`${PATH}/customerSupport`)}</Text>
          <View style={{ marginTop: 16 }}>
            <Text
              style={{
                fontFamily: "NotoSansDevanagari-Regular",
                color: "rgba(0, 0, 0, 0.56)",
                fontSize: 14,
                lineHeight: 20,
              }}
            >
              {message}
              <Text
                style={{
                  fontFamily: "NotoSansDevanagari-SemiBold",
                  color: colors.mediumBlack,
                  fontSize: 14,
                  lineHeight: 20,
                  marginLeft: 5,
                }}
              >
                {ticketId}
              </Text>
              {endingMessage}
            </Text>
          </View>

          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-end",
              marginTop: 25,
            }}
          >
            <TouchableOpacity
              onPress={() => {
                navigateToTicket(ticketId);
              }}
            >
              <View style={{ padding: 3, marginRight: 20 }}>
                <Text
                  style={{
                    color: colors.lightBlack,
                    fontFamily: "NotoSansDevanagari-Regular",
                    fontWeight: "bold",
                    fontSize: 16,
                  }}
                >
                  {buttonText1}
                </Text>
              </View>
            </TouchableOpacity>
            <TouchableOpacity
              onPress={() => {
                navigateToSupport();
              }}
            >
              <View style={{ padding: 3 }}>
                <Text
                  style={{
                    color: buttonText2Color || colors.primary,
                    fontWeight: "bold",
                    fontSize: 16,
                    fontFamily: "NotoSansDevanagari-Regular",
                  }}
                >
                  {buttonText2}
                </Text>
              </View>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </Modal>
  );
};

export default TicketDialog;
